module.exports = __webpack_public_path__ + "img/tuboDrenoEspecificacoes2.a5f7ecd8.png";